export default __webpack_public_path__ + "a861b0d3d4711d64c91322f067af8b48.png";